import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { Title, TitlePreset, Color } from '@pegasus/ui-components/components/title';
import Translate from '@client/components/shared/translation/Translate';
import styles from './styles.scss';

export const SectionTitle = ({ message }) => (
    <div styleName="wrapper">
        <Title preset={TitlePreset.S} color={Color.dark} styleName="header">
            <Translate message={message} />
        </Title>
    </div>
);


SectionTitle.propTypes = {
    message: PropTypes.string.isRequired
};

export default CSSModules(SectionTitle, styles);
